class ProductZoom {
    constructor (theme, elem) {
        this._name = elem.id || this.constructor.name
        this._theme = theme
        this._elem = elem
        this._images = JSON.parse(elem.dataset.productZoom)
        this._currentIndex = 0
        this._countdown = 500
    }
    onInit () {
        if (this._images.length > 0) {
            this.waitForSlider()
        }
    }
    waitForSlider () {
        const gallery = document.querySelector('[data-product-gallery] .tns-outer')
        if (gallery) {
            const images = gallery.querySelectorAll('[data-zoom]')
            if (images.length > 0) {
                for (let image of images) {
                    image.addEventListener('click', (e) => { this.changeImage(parseInt(e.currentTarget.dataset.index) - 1); this.openModal() })
                }
            }

            const close = this._elem.querySelectorAll('[data-product-zoom-close]')
            if (close.length > 0) {
                for (let btn of close) {
                    btn.addEventListener('click', () => { this.closeModal() })
                }
            }
            const next = this._elem.querySelector('[data-product-zoom-next]')
            if (next) {
                next.addEventListener('click', () => { this.nextImage() })
            }
            const prev = this._elem.querySelector('[data-product-zoom-prev]')
            if (prev) {
                prev.addEventListener('click', () => { this.prevImage() })
            }
        } else {
            if (this._countdown > 0) {
                this._countdown--
                window.requestAnimationFrame(() => { this.waitForSlider() })
            }
        }
    }
    changeImage (index) {
        if (index > -1) {
            const img = this._elem.querySelector('img')
            if (img) {
                img.src = ''
                window.requestAnimationFrame(() => { img.src = this._images[index] })
                this._currentIndex = index
            }
        }
    }
    openModal () {
        this._elem.classList.add('active')
    }
    closeModal () {
        this._elem.classList.remove('active')
    }
    nextImage () {
        this.changeImage(this.getIndex(this._currentIndex + 1))
    }
    prevImage () {
        this.changeImage(this.getIndex(this._currentIndex - 1))
    }
    getIndex (n) {
        if (n > this._images.length - 1) {
            return 0
        }
        if (n < 0) {
            return this._images.length - 1
        }
        return n
    }
}

export default ProductZoom



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductZoom.js